import styled from 'styled-components';
import { colors } from '../../constants';

export const DividerLine = styled.div`
    width: 100%;
    height: 1px;
    margin: 40px 0;
    background-color: ${colors.greyLight};
`;
